import Request from '@/utils/request'

const MineApi = {
    // 我的收获地址
    getAddressList(data) {
        return Request('/app/userAddress/list', 'get', data)
    },
    // 我的-v2
    getIncomeMe(data) {
        return Request('/app/income/me', 'get', data)
    },
    // 查看未读消息
    getUnReadStatus2() {
        return Request('/app/msg/unReadStatus2', 'get')
    },
    // 获取发圈素材列表
    getSocialMediaKitList(data) {
        return Request('/app/sourceMaterial/list', 'get', data)
    },
    // 获取未读条数
    getSocialMediaKitListNoCount() {
        return Request('/app/sourceMaterial/getNoCount', 'get')
    },
    // 获取客服留言列表
    getContactSupportList() {
        return Request('/app/customer/message/list', 'get')
    },
    // 客服留言回答
    getContactSupportAnswer(data) {
        return Request('/app/customer/message/answer', 'get', data)
    },
    // 昵称保存
    nicknameSave(data) {
        return Request('/app/user/nicknameSave', 'post', data)
    },
    // 头像保存
    avatarSave(data) {
        return Request('/app/user/avatarSave', 'post', data)
    },
    // 密码保存
    passwordSave(data) {
        return Request('/app/user/passwordSave', 'post', data)
    },
    // 年龄组保存
    ageGroupSave(data) {
        return Request('/app/user/ageGroupSave', 'post', data)
    },
    // 性别保存
    sexSave(data) {
        return Request('/app/user/sexSave', 'post', data)
    },
    // 邀请人绑定
    inviterBind(data) {
        return Request('/app/user/inviterBind', 'post', data)
    },
    // 我的客户列表
    myCustomers(data) {
        return Request('/app/user/myCustomers', 'get', data)
    },
    // 我的客户total
    myCustomersNums() {
        return Request('/app/user/myCustomersNums', 'get')
    },
    // 修改昵称
    updateNickname(data) {
        return Request('/app/tutor/updateNickname', 'post', data)
    },
    // 删除地址
    userAddressDelete(data) {
        return Request('/app/userAddress/delete', 'post', data)
    },
    // 保存/编辑地址
    userAddressSave(data) {
        return Request('/app/userAddress/save', 'post', data)
    },
    // 保存/编辑地址
    userCancel() {
        return Request('/app/user/cancel', 'post')
    },
    // 重报订单详情
    repeatSubmitDetail(data) {
        return Request('/app/shopping/order/repeatSubmitDetail', 'get', data)
    },
    // 修改地址
    modifyAddress(data) {
        return Request('/app/shopping/order/modifyAddress', 'post', data)
    },
    // 版本检测
    check(data) {
        return Request('/app/version/check', 'post', data)
    },
}

export default MineApi